import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Steps } from 'antd';
import { ExclamationCircleFilled, HomeFilled, SyncOutlined, CloudUploadOutlined, ClockCircleFilled, CheckOutlined, ReloadOutlined, TableOutlined } from '@ant-design/icons';
import './WizardProgress.css';

const WizardProgress = ({ currentStep = 0 }) => {
	const navigate = useNavigate();

	const handleRestart = () => {
		Modal.confirm({
			title: '¿Estás seguro de que quieres reiniciar el proceso?',
			icon: <ExclamationCircleFilled />,
			content: 'Se perderá todo el progreso actual y regresarás al inicio del proceso. Esta acción no se puede deshacer.',
			okText: 'Sí, reiniciar',
			okType: 'danger',
			cancelText: 'Cancelar',
			centered: true,
			onOk() {
				// Clear wizard state
				localStorage.removeItem('wizardState');
				// Navigate to start
				navigate('/wizard/start');
			},
		});
	};
	
	const stepsData = [
		{ 
			title: 'INICIAR',
			description: '',
			icon: currentStep > 0 ? <SyncOutlined /> : <HomeFilled />,
			status: currentStep === 0 ? 'process' : 'finish'
		},
		{
			title: 'PASO 1:',
			description: 'ESQUEMAS',
			icon: <TableOutlined />,
			status: currentStep === 1 ? 'process' : currentStep > 1 ? 'finish' : 'wait'
		},
		{ 
			title: 'PASO 2:',
			description: 'CICLOS',
			icon: <SyncOutlined />,
			status: currentStep === 2 ? 'process' : currentStep > 2 ? 'finish' : 'wait'
		},
		{ 
			title: 'PASO 3:',
			description: 'CARGAR',
			icon: <CloudUploadOutlined />,
			status: currentStep === 3 ? 'process' : currentStep > 3 ? 'finish' : 'wait'
		},
		{ 
			title: 'ESTADO DE CARGA',
			description: '',
			icon: <ClockCircleFilled />,
			status: currentStep === 4 ? 'process' : currentStep > 4 ? 'finish' : 'wait'
		}
	];

	// #DDE6F1
	const customItems = stepsData.map((step, index) => ({
		title: step.title,
		description: step.description,
		status: step.status,
		icon: (
			<div style={{
				width: '40px',
				height: '40px',
				borderRadius: '50%',
				border: `2px solid ${step.status === 'finish' || step.status === 'process' ? '#415577' : '#d9d9d9'}`,
				backgroundColor: step.status === 'finish' || step.status === 'process' ? '#415577' : 'white',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				fontSize: '18px',
				color: step.status === 'finish' || step.status === 'process' ? 'white' : '#d9d9d9'
			}}>
				{step.status === 'finish' && index > 0 ? <CheckOutlined style={{ fontSize: '16px' }} /> : step.icon}
			</div>
		)
	}));

	// Override first step to show restart functionality
	if (currentStep > 0) {
		customItems[0] = {
			...customItems[0],
			icon: (
				<div 
					onClick={handleRestart}
					title="Haz clic para reiniciar el proceso"
					style={{
						width: '40px',
						height: '40px',
						borderRadius: '50%',
						border: '2px solid #415577',
						backgroundColor: '#415577',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: '18px',
						color: 'white',
						cursor: 'pointer',
						transition: 'all 0.3s ease'
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = '#FF4D4F';
						e.currentTarget.style.borderColor = '#FF4D4F';
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = '#415577';
						e.currentTarget.style.borderColor = '#415577';
					}}
				>
					<ReloadOutlined />
				</div>
			)
		};
	}

	return (
		<div className="wizard-progress">
			<Steps
				current={currentStep}
				items={customItems}
				labelPlacement='vertical'
			/>
		</div>
	);
};

export default WizardProgress;